export const COOP_GA_ORDER_COUNT_SENT = 'gaOcs';
